import styled from 'styled-components'

const Button = styled.div`
  a {
    display: block;
    background-color: var(--main-color);
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#65e345),
      to(var(--main-color))
    );
    background-image: -webkit-linear-gradient(top, #65e345, var(--main-color));
    background-image: -moz-linear-gradient(top, #65e345, var(--main-color));
    background-image: -ms-linear-gradient(top, #65e345, var(--main-color));
    background-image: -o-linear-gradient(top, #65e345, var(--main-color));
    margin: 36px;
    font-weight: 900;
    width: 90px;
    height: 90px;
    position: relative;
    text-align: center;
    line-height: 90px;
    border-radius: 50%;
    box-shadow: 0px 3px 8px #aaa, inset 0px 2px 3px var(--white);
    cursor: pointer;
    color: white;

    &:hover {
      text-decoration: none;
      color: #555;
      background: #f5f5f5;
      cursor: pointer;
    }
  }
`
const openBotAndTransferToModule = (moduleName) => {
  window.postMessage({ type: 'dbOpenBot', module: `${moduleName}` }, '*')
}

const HelpButton = ({ moduleName }) => {
  return (
    <Button>
      <a onClick={() => openBotAndTransferToModule(moduleName)}> Bot Help</a>
    </Button>
  )
}

export default HelpButton
